import { Component, OnInit } from '@angular/core';
import { AuthService } from './../auth/auth.service';
import { Observable, map } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  isLoggedIn$: Observable<boolean> | undefined;
  btnStatus$: Observable<boolean> | undefined;
  hellotext: string = 'Admin';
  newUserId: number | undefined;
  dropdownData: any;
  projData: any;
  newCname: string | undefined;
  newEventId: number | undefined;
  newProjId: number | undefined;
  newEmail: string | undefined;
  edcdclit: boolean | undefined;
  value: any;
  delname: any;
  dltsuccess: any;
  listServiceFeature: any = [];
  str: string | undefined;
  condId: string | number | boolean | undefined;
  delprojname: any;
  editprojname: any;
  projName: string | undefined;
  editsuccess: any;
  selectedItem: any;
  food: any;
  selectedValue: number | undefined;
  rootDomainUrl: any;
  defaultId: string | undefined;
  selectedValueNew: any;
  isProject: boolean = false;
  isAddNew: boolean = false;

  foods = [
    { value: 'steak-0', viewValue: 'kumar park phase 1' },
    { value: 'pizza-1', viewValue: 'kumar park phase 2' },
    { value: 'tacos-2', viewValue: 'kumar park phase 3' },
  ];
  builders = [
    { value: 'steak-0', viewValue: 'kumar builders' },
    { value: 'pizza-1', viewValue: 'Sai builders' },
    { value: 'tacos-2', viewValue: 'Rahul developers' },
  ];
  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private router: Router
  ) {
  }
  modo(event: { value: number }) {
    this.authService.changeeventId(event.value);
    this.authService.chnBtnStatus();

    this.http
      .get(
        this.rootDomainUrl +
          'adeos/api/adeosprojects.php?user_id=' +
          this.newEventId
      )
      .pipe(map((res) => res))
      .subscribe((data) => {
        this.projData = data;

        if (this.projData.success == '3') {
          this.authService.changeFirstLoginVal('N');
        } else {
          this.authService.changeFirstLoginVal('T');
        }
        if (this.projData.success == '3' || this.projData.success == '1') {
          this.router
            .navigateByUrl('/register', { skipLocationChange: true })
            .then(() => this.router.navigate(['mrfd']));
        }
        if (this.isAddNew == true) {
          this.router
            .navigateByUrl('/register', { skipLocationChange: true })
            .then(() => this.router.navigate(['addclient']));
        }
      });
    this.isAddNew = false;
    if (this.edcdclit) {
      this.edcdclit = false;
    }
    //	this.router.navigate(["logedin"]);
  }
  edclit(ev: { id: any }) {
    //event.stopPropagation();
    this.authService.changeEditClientVal(ev.id);
    //  this.router.navigate(["edit"]);
    this.router
      .navigateByUrl('/register', { skipLocationChange: true })
      .then(() => this.router.navigate(['edit']));
    event?.stopPropagation();
  }

  addNewClient() {
    this.router.navigate(['addclient']);
    event?.stopPropagation();
    this.isAddNew = true;
  }

  helloalt(ev: { name: string; id: string }) {
    event?.stopPropagation();
    this.delname = ev.name;

    var modal = document.getElementById('myModal');

    var btn = document.getElementById('cancl');

    var dlt = document.getElementById('delt');

    if (modal) modal.style.display = 'block';
    if (btn) {
      btn.onclick = function () {
        if (modal) modal.style.display = 'none';
      };
    }

    if (dlt) {
      dlt.onclick = () => {
        this.http
          .get(
            this.rootDomainUrl + 'adeos/api/delete_user.php?user_id=' + ev.id
          )
          .pipe(map((res) => res))
          .subscribe((data) => {
            if (data) {
              this.dltsuccess = data;
              this.router
                .navigateByUrl('/register', { skipLocationChange: true })
                .then(() => this.router.navigate(['logedin']));
              if (modal) modal.style.display = 'none';

              if (this.dltsuccess.success == 1) {
                setTimeout(
                  () => alert(ev.name + ' is deleted from database'),
                  2000
                );
              }
            }
          });
      };
    }
    window.onclick = function (event) {
      if (event.target == modal && modal) {
        modal.style.display = 'none';
      }
    };
  }

  delProject(ev: { proj_name: any; id: string; name: string }) {
    event?.stopPropagation();

    this.delprojname = ev.proj_name;

    var modal = document.getElementById('myModaldelete');

    var btn = document.getElementById('canclproj');

    var dlt = document.getElementById('deltproj');

    if (modal) modal.style.display = 'block';

    if (btn) {
      btn.onclick = function () {
        if (modal) modal.style.display = 'none';
      };
    }
    if (dlt) {
      dlt.onclick = () => {
        this.http
          .get(
            this.rootDomainUrl + 'adeos/api/delete_project.php?proj_id=' + ev.id
          )
          .pipe(map((res) => res))
          .subscribe((data) => {
            if (data) {
              this.dltsuccess = data;
              this.router
                .navigateByUrl('/register', { skipLocationChange: true })
                .then(() => this.router.navigate(['logedin']));
              if(modal) modal.style.display = 'none';

              if (this.dltsuccess.success == 1) {
                setTimeout(
                  () => alert(ev.name + ' is deleted from database'),
                  2000
                );
              }
            }
          });
      };
    }
    window.onclick = function (event) {
      if (event.target == modal) {
        if (modal) modal.style.display = 'none';
      }
    };
  }

  editProject(ev: { proj_name: any; id: string | number | boolean }) {
    event?.stopPropagation();

    this.projName = '';
    this.editprojname = ev.proj_name;

    var modal = document.getElementById('myModaledit');

    var btn = document.getElementById('cancledit');

    var dlt = document.getElementById('editproj');

    if (modal) modal.style.display = 'block';

    if (btn) {
      btn.onclick = function () {
        if (modal) modal.style.display = 'none';
      };
    }
    if (dlt) {
      dlt.onclick = () => {
        if (this.newEmail == 'anuprathi1@gmail.com') {
          this.condId = this.newEventId;
        } else {
          this.condId = this.newUserId;
        }

        const bodyparm = new HttpParams()
          .set('user_id', this.condId ? this.condId : '')
          .set('proj_id', ev.id)
          .set('proj_name', this.projName ? this.projName : '');
        this.http
          .post(this.rootDomainUrl + 'adeos/api/edit_project.php', bodyparm)
          .subscribe((data) => {
            if (data) {
              this.editsuccess = data;
              this.router
                .navigateByUrl('/register', { skipLocationChange: true })
                .then(() => this.router.navigate(['logedin']));
              if (modal) modal.style.display = 'none';
              if (this.editsuccess.success == 1) {
                setTimeout(
                  () => alert('Project name edited in database'),
                  2000
                );
              }
            }
          });
      };
    }
    window.onclick = function (event) {
      if (event.target == modal && modal) {
        modal.style.display = 'none';
      }
    };
  }

  projListDetails(event: { value: number }) {
    this.authService.changeprojId(event.value);

    /*  if(this.newEmail == 'anuprathi1@gmail.com' ){
      this.condId = this.newEventId;
     }
    else{
     this.condId = this.newUserId;
    }
         
    var embCodeUrl = this.rootDomainUrl + 'adeos/api/get_proj_code.php?user_id=' + this.condId + '&proj_id='+ event.value;
    
     return this.http.get(embCodeUrl).map(res => res)
          .subscribe((data) => {
            // this.ebmbededCode = data;
    
          }) */
  }
  refreshmrfd() {
    this.authService.changeIsUpdated('N');
    this.router
      .navigateByUrl('/register', { skipLocationChange: true })
      .then(() => this.router.navigate(['mrfd']));
  }

  projLoad() {
    this.authService.projectValues().subscribe((data) => {
      this.projData = data;
      if (this.projData.success !== 3) {
        this.selectedValue = this.projData.clientLists[0].id;
      }
      if (this.selectedValue) this.authService.changeprojId(this.selectedValue);
      
      if (this.projData.success != '3') {
        this.isProject = true;
      }
      if (
        this.newEmail != 'demo@ecomatrix.io' &&
        this.newEmail != 'anuprathi1@gmail.com'
      ) {
        this.refreshmrfd();
      }
    });
  }

  loadProjects() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    this.http
      .get(
        this.rootDomainUrl +
          'adeos/api/adeosprojects.php?user_id=' +
          this.condId
      )
      .pipe(map((res) => res))
      .subscribe((data) => {
        this.projData = data;
      });
  }

  ngOnInit() {
    this.defaultId = this.authService.demoid;
    this.rootDomainUrl = this.authService.rootDomainUrl;

    this.edcdclit = false;

    this.btnStatus$ = this.authService.btnStatus;
    this.authService.currenteventId.subscribe(
      (newEventId) => (this.newEventId = newEventId)
    );
    this.authService.currentprojId.subscribe(
      (newProjId) => (this.newProjId = newProjId)
    );
    this.authService.currentUserId.subscribe(
      (newUserId) => (this.newUserId = newUserId)
    );
    this.authService.currentClientName.subscribe(
      (newCname) => (this.newCname = newCname)
    );
    this.authService.currentClientEmail.subscribe(
      (newEmail) => (this.newEmail = newEmail)
    );
    this.isLoggedIn$ = this.authService.isLoggedIn;

    this.router.events.subscribe((event: any) => {
      if (event['url'] && event['url'] == '/logedin') {
        if (this.newEmail != 'anuprathi1@gmail.com') {
          this.projLoad();
        }
        this.authService.dropDownValues().subscribe((data) => {
          this.dropdownData = data;
          //  this.selectedValueNew = this.dropdownData.clientLists[2].id;
          this.loadProjects();
        });
      }
    });
  }

  onLogout() {
    this.authService.logout();
  }
}
export class ListItemSimplified {
  id: string | undefined;
  proj_name: string | undefined;
}
